import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSResultadosSorteo(eventoId, sorteoGlobalId, participantes) {
      let titulo = 'Sorteo';
      let xlsName = ''; 
      if (eventoId) {
        xlsName = `sorteo_evento_${eventoId.toString().trim()}.xlsx`; 
      } else {
        xlsName = `sorteo_global_${sorteoGlobalId.toString().trim()}.xlsx`; 
      }
      
      this.exportXLSSorteo(titulo, xlsName, participantes);
    },
    
    exportXLSListadoGanadores(eventoId, participantes) {
      let titulo = 'Ganadores';
      let xlsName = `ganadores_evento_${eventoId.toString().trim()}.xlsx`;
      
      this.exportXLSSorteo(titulo, xlsName, participantes);
    },

    exportXLSSorteo (titulo, xlsName, participantes) {
      
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: titulo,
        Subject: titulo,
        Author: "RegistrosPromocionales",
        CreatedDate: new Date()
      };
    
      let data = [
        [
          'Posicion', 
          'Nombre', 
          'Nro.Documento',
          'Fecha Nacim.', 
          'Nro.Celular', 
          'Email'        
        ]
      ];

      participantes.forEach(participante => {
        data.push([
          participante.posicion.toString().trim(),
          participante.nombreCompleto.trim(),
          participante.documentoNumero.trim(),
          this.$options.filters.fecha(participante.fechaNacimiento),
          participante.numeroCelular.trim(),
          participante.email.trim(),
        ]);
      });

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, titulo);

      XLSX.writeFile(wb, xlsName);

      return;
    },
  }
}
